import {vec3, vec4, mat3, mat4} from 'gl-matrix';
import {create_buffer} from './webgl';
import {use_program, load_texture} from './shader-utils';
import {clamp} from './utils';

// a ray-traced sphere
export function init_sphere() {

    const params = {
        useBurley: false,
        roughness: 0.5,
        reflectance: 0.0,
        lightIntensity: 5.0,
    };

    const buffers = {
        triangle: create_buffer(gl.ARRAY_BUFFER, [-1, -1, 3, -1, -1, 3]),
    };

    const textures = {
        // world_color: load_texture({
        //     url: 'images/world-equirect-5400x2700.jpg',
        //     max_anisotropy: 8,
        // }),
    };

    const mat_proj_inv = mat4.create();
    const mat_view_rot_inv = mat3.create();

    function draw(env) {
        const pgm = use_program('sphere');
        if (!pgm)
            return;

        if (!env.params.sphere)
            env.params.shading = params;

        // if (quadtree)
        //     quadtree.draw(env);
        //
        gl.bindBuffer(gl.ARRAY_BUFFER, buffers.triangle);
        pgm.vertexAttribPointer('aCoord', 2, gl.FLOAT, false, 0, 0);

        mat4.invert(mat_proj_inv, env.camera.projection);
        pgm.uniformMatrix4fv('uMatProjInv', mat_proj_inv);
        pgm.uniformMatrix4fv('uMatView', env.camera.view);
        pgm.uniform3fv('uLightPos', env.light.pos);
        pgm.uniform4f('uColor', 1.0, 0.0, 0.0, 0.1);
        // pgm.uniformSampler2D('uTexColor', textures.world_color);
        pgm.uniform2f('uResolution', gl.drawingBufferWidth, gl.drawingBufferHeight);
        // pgm.uniform1i('uShowTexCacheLevel', env.params.layers.cacheTexture ? env.params.layers.cacheTextureLevel : -1);

        // if (quadtree) {
        //     pgm.uniformSampler2D('uTexCacheIndex', quadtree.texture_cache_index);
        //     pgm.uniformSampler2D('uTexCacheData', quadtree.texture_cache_data);
        // }
        //
        {
            // billboard matrix for the sphere impostor
            const b = mat_view_rot_inv;
            const v = env.camera.view;
            b[0] = v[0]; b[1] = v[4]; b[2] = v[8];
            b[3] = v[1]; b[4] = v[5]; b[5] = v[9];
            b[6] = v[2]; b[7] = v[6]; b[8] = v[10];
            pgm.uniformMatrix3fv('uMatViewRotInv', b);
        }

        {
            params.roughness = clamp(params.roughness, 0, 1);
            params.reflectance = clamp(params.reflectance, 0, 1);

            // shading parameters
            pgm.uniform1i('uUseBurley', params.useBurley ? 1 : 0);
            pgm.uniform1f('uRoughness', params.roughness);
            pgm.uniform1f('uReflectance', params.reflectance);
            pgm.uniform1f('uLightIntensity', params.lightIntensity);
        }

        gl.disable(gl.DEPTH_TEST);
        // gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        gl.disable(gl.BLEND);
    }
    
    return {draw};
}

